import PixelRatio from "react-native-web/dist/exports/PixelRatio";
import Platform from "react-native-web/dist/exports/Platform";
/**
 * When a user increases text size using device accessibility settings, some elements
 * should also scale, such as icons alongside text and space between paragraphs.
 *
 * @param {number} [value] - the value to multiply; defaults to system default font size
 * @param {number} [maxScale] - the maximum multiplier to apply; defaults to no maximum
 */
export const scaleWithText = function (value) {
  let maxScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  if (!value) return value;
  const scale = Math.min(PixelRatio.getFontScale(), maxScale) || 1;
  return value * scale;
};

/**
 * Native only, returns `undefined` on Web.
 *
 * Enforces `fontScaleCap` theme tokens as the maximum font size text can become
 * after iOS or Android font scaling, to give consistent accessible maximum sizes
 * that don't make the content unusable.
 *
 * The return value of this function can be used as a React Native `Text` element's
 * `maxFontSizeMultiplier` prop value.
 */
export const getMaxFontMultiplier = _ref => {
  let {
    fontSize,
    fontScaleCap
  } = _ref;
  if (Platform.OS === 'web' || !fontScaleCap || !fontSize) return undefined;
  if (fontScaleCap <= fontSize) return 1;
  return fontScaleCap / fontSize;
};